import React from 'react';
import "./Dashboard.css";
import Sidebar from "../../Component/sidebar/sidebar";
import Header from "../../Component/header/Header";
import Content from '../../Component/sub-dashboard/Content';

function Dashboard() {
    return(
        <div className="container">
            <div className="row row-cols-2">
                {/* sidebar design */}
                <div className="col-2 sidebar">
                    <Sidebar />
                </div>

                {/* content section */}
                <div className="col-10 content">
                    <Header title={"Dashboard"} />
                    {/* content secction */}
                     <Content />
                </div>
            </div>
        </div>
    )
};

export default Dashboard;